var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import { createRoot } from "react-dom/client";
import { getConfigVar } from "../../utils/Configuration";
import { addCheckClickOutside, concatClassNames, createElementWithClass, range, trackOnElement } from "../../utils/Functions";
import { Button } from "../layout/Button";
import { Tooltip } from "../layout/Tooltip";
import { BaseInput } from "./BaseInput";
import { Input } from "./Input";
export var TimeSelect;
(function (TimeSelect) {
    TimeSelect["HOURS"] = "HH";
    TimeSelect["MINUTES"] = "mm";
    TimeSelect["SECONDS"] = "ss";
})(TimeSelect || (TimeSelect = {}));
var Timepicker = /** @class */ (function (_super) {
    __extends(Timepicker, _super);
    function Timepicker(props) {
        var _this = _super.call(this, props, { show: false }, props.defaultValue || null) || this;
        _this.pickerContainer = createElementWithClass("div", "dolfo-timepicker-select");
        _this.componentDidMount = function () { return addCheckClickOutside(_this.blurInput, _this, _this.pickerContainer); };
        _this.componentWillUnmount = function () { return setTimeout(function () {
            var _a;
            (_a = _this.pickerRoot) === null || _a === void 0 ? void 0 : _a.unmount();
            _this.pickerContainer.remove();
        }); };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var _a, _b, _c, _d, _e;
            if (((_a = prevProps.defaultValue) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = _this.props.defaultValue) === null || _b === void 0 ? void 0 : _b.getTime()) && !isNaN((_c = _this.props.defaultValue) === null || _c === void 0 ? void 0 : _c.getTime()))
                _this.dispatchValue(_this.props.defaultValue);
            if (prevState.show !== _this.state.show || ((_d = prevState.value) === null || _d === void 0 ? void 0 : _d.getTime()) !== ((_e = _this.state.value) === null || _e === void 0 ? void 0 : _e.getTime())) {
                var _f = _this.state, show = _f.show, value_1 = _f.value, select = _this.props.select;
                if (!show && _this.pickerRoot) {
                    setTimeout(function () {
                        if (_this.pickerRoot)
                            _this.pickerRoot.unmount();
                        _this.pickerContainer.remove();
                        _this.pickerRoot = null;
                    });
                }
                else if (show) {
                    var minutesRange = _this.getRange();
                    if (!_this.pickerRoot)
                        _this.pickerRoot = createRoot(_this.pickerContainer);
                    _this.pickerRoot.render(React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", { className: "head" },
                                (!select || select.includes(TimeSelect.HOURS)) && React.createElement("td", null,
                                    React.createElement("strong", null, getConfigVar("HOURS")),
                                    React.createElement(Input, { decimals: 0, type: "number", defaultValue: value_1 === null || value_1 === void 0 ? void 0 : value_1.getHours(), min: 0, max: 23, onChange: function (v) { return _this.changeDate(v, TimeSelect.HOURS); } })),
                                (!select || select.includes(TimeSelect.MINUTES)) && React.createElement("td", null,
                                    React.createElement("strong", null, getConfigVar("MINUTES")),
                                    React.createElement(Input, { decimals: 0, type: "number", defaultValue: value_1 === null || value_1 === void 0 ? void 0 : value_1.getMinutes(), min: 0, max: 59, onChange: function (v) { return _this.changeDate(v, TimeSelect.MINUTES); } })),
                                (select === null || select === void 0 ? void 0 : select.includes(TimeSelect.SECONDS)) && React.createElement("td", null,
                                    React.createElement("strong", null, getConfigVar("SECONDS")),
                                    React.createElement(Input, { decimals: 0, type: "number", defaultValue: value_1 === null || value_1 === void 0 ? void 0 : value_1.getSeconds(), min: 0, max: 59, onChange: function (v) { return _this.changeDate(v, TimeSelect.SECONDS); } }))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("div", null, range(0, 24).map(function (n) { return React.createElement(Button, { size: "small", shape: "pill", color: (value_1 === null || value_1 === void 0 ? void 0 : value_1.getHours()) === n ? "blue2" : "white", key: n, onClick: function () { return _this.changeDate(n, TimeSelect.HOURS); } }, n < 10 ? "0" + n : n); }))),
                                React.createElement("td", null,
                                    React.createElement("div", null, minutesRange.map(function (n) { return React.createElement(Button, { size: "small", shape: "pill", color: (value_1 === null || value_1 === void 0 ? void 0 : value_1.getMinutes()) === n ? "blue2" : "white", key: n, onClick: function () { return _this.changeDate(n, TimeSelect.MINUTES); } }, n < 10 ? "0" + n : n); }))),
                                (select === null || select === void 0 ? void 0 : select.includes(TimeSelect.SECONDS)) && React.createElement("td", null,
                                    React.createElement("div", null, minutesRange.map(function (n) { return React.createElement(Button, { size: "small", shape: "pill", color: (value_1 === null || value_1 === void 0 ? void 0 : value_1.getSeconds()) === n ? "blue2" : "white", key: n, onClick: function () { return _this.changeDate(n, TimeSelect.SECONDS); } }, n < 10 ? "0" + n : n); })))))));
                    document.body.appendChild(_this.pickerContainer);
                    trackOnElement(_this.pickerContainer, _this, true, false, ".dolfo-input-label");
                }
            }
        };
        _this.getRange = function () {
            var range0_59 = range(0, 60), steps = _this.props.steps;
            if (steps && steps > 0) {
                var roundSteps_1 = Math.round(steps);
                return range0_59.filter(function (n) { return n % roundSteps_1 === 0; });
            }
            return range0_59;
        };
        _this.changeDate = function (n, key) {
            var value = _this.state.value, date = isNaN(new Date(value).getTime()) ? new Date() : new Date(value);
            if (!value)
                date.setHours(0, 0, 0, 0);
            if (key === TimeSelect.HOURS)
                date.setHours(n);
            if (key === TimeSelect.MINUTES)
                date.setMinutes(n);
            if (key === TimeSelect.SECONDS)
                date.setSeconds(n);
            date.setMilliseconds(0);
            _this.dispatchValue(date);
        };
        _this.blurInput = function (e) {
            var target = e.target;
            if (_this.pickerContainer.isEqualNode(target) || _this.pickerContainer.contains(target))
                return false;
            _this.setShowing(false);
            return true;
        };
        _this.focusInput = function (e) {
            var _a = _this.props, onFocus = _a.onFocus, disabled = _a.disabled;
            if (disabled)
                return;
            _this.setShowing(true);
            if (onFocus)
                onFocus(e);
        };
        _this.setShowing = function (show) { return _this.setState({ show: show }); };
        _this.decodeTime = function () {
            var value = _this.state.value;
            if (!value || isNaN(value.getTime()))
                return "";
            return moment(new Date(value)).format(_this.getFormatPieces());
        };
        _this.onChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, disabled = _a.disabled, value = e.target.value, date = value ? new Date(value) : null;
            if (disabled)
                return;
            _this.setState({ value: date }, function () {
                if (onChange)
                    onChange(date, e);
            });
        };
        _this.getFormatPieces = function () { return _this.props.timeFormat || (_this.props.select || Timepicker.DEFAULT_FORMAT).join(":"); };
        _this.checkInternalValue = function (e) {
            var _a = _this.props, onBlur = _a.onBlur, disabled = _a.disabled, internalValue = _this.state.internalValue;
            if (disabled)
                return;
            if (internalValue != null) {
                var momentDate = moment(internalValue, _this.getFormatPieces());
                if (momentDate.isValid())
                    _this.dispatchValue(momentDate.toDate());
                else
                    _this.dispatchValue(undefined);
                _this.setInternalValue(null);
                _this.setShowing(null);
                if (onBlur)
                    onBlur(e);
            }
            else if (onBlur)
                onBlur(e);
        };
        _this.render = function () {
            var _a = _this.props, required = _a.required, disabled = _a.disabled, className = _a.className, style = _a.style, select = _a.select, _b = _this.state, value = _b.value, internalValue = _b.internalValue;
            return React.createElement("div", { className: "dolfo-control timepicker", ref: function (r) { return _this.node = r; } },
                _this.getLabel(),
                React.createElement("div", { className: "dolfo-input-container" },
                    React.createElement("input", { type: "text", onChange: function (e) {
                            var value = e.target.value, momentDate = moment(new Date(value), _this.getFormatPieces()), date = momentDate.toDate(), nativeEvent = e.nativeEvent;
                            if (nativeEvent.isBase) {
                                if (!value) {
                                    _this.onChange(e);
                                    return;
                                }
                                var dateToCheck = !momentDate.isValid() ? null : date;
                                if (dateToCheck) {
                                    if (select) {
                                        if (!select.includes(TimeSelect.HOURS))
                                            dateToCheck.setHours(0);
                                        if (!select.includes(TimeSelect.MINUTES))
                                            dateToCheck.setMinutes(0);
                                        if (!select.includes(TimeSelect.SECONDS))
                                            dateToCheck.setSeconds(0);
                                    }
                                    else
                                        dateToCheck.setSeconds(0, 0);
                                }
                                e.target.value = dateToCheck === null || dateToCheck === void 0 ? void 0 : dateToCheck.toString();
                                _this.onChange(e);
                            }
                            else
                                _this.setInternalValue(value);
                        }, onKeyDown: function (e) {
                            if (e.code === "Tab")
                                _this.blurInput(new Event(e.type, e));
                        }, value: internalValue != null ? internalValue : _this.decodeTime(), required: required, disabled: disabled, onFocus: _this.focusInput, onBlur: _this.checkInternalValue, className: concatClassNames(["dolfo-picker-input", "dolfo-input-text"], className), style: style, autoComplete: "new-password", ref: function (r) { return _this.input = r; } }),
                    !disabled && value && React.createElement(Tooltip, { label: getConfigVar("RESET"), position: "left" },
                        React.createElement(FontAwesomeIcon, { icon: faXmark, className: "dolfo-input-reset", onClick: _this.reset })),
                    !disabled && React.createElement(Tooltip, { label: getConfigVar("SELECT"), position: "left" },
                        React.createElement(Button, { className: "dolfo-picker-btn", onClick: function () { return _this.input.focus(); }, size: "small", color: "white" },
                            React.createElement(FontAwesomeIcon, { icon: faClock })))));
        };
        return _this;
    }
    Timepicker.DEFAULT_FORMAT = [TimeSelect.HOURS, TimeSelect.MINUTES];
    return Timepicker;
}(BaseInput));
export { Timepicker };
